// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-table .selected-row {\n  background: rgb(239, 239, 255);\n}\n", ""]);
// Exports
module.exports = exports;
